import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { vennHealthConstants  } from '../../../shared/vennHealthConstants';
import { SelectionsErrorModel } from '@app/models/selections-model';
import { AccountService } from '@app/services/account-service';

@Component({
  selector: 'app-data-sets',
  templateUrl: './data-sets.component.html',
  styleUrls: ['./data-sets.component.css']
})
export class DataSetsComponent implements OnInit {

  availableDataSets: Array<{ text: string; value: number }> = vennHealthConstants.nHanesYears;
  
  selectedDataSets: any = this.availableDataSets;
  validationErrors: SelectionsErrorModel[] = [];

  isChecked = false;
  hasErrors = false;
  isDemoUser = false;

  constructor(
    private readonly sharedService: SharedService, 
    private readonly accountService: AccountService
  ) { }

  ngOnInit(): void {
    const account = this.accountService.accountValue;
    if (account) {
      this.isDemoUser = account.roles.includes(103);
      if (this.isDemoUser) {
        this.availableDataSets = vennHealthConstants.nHanesYears;
        this.selectedDataSets = [vennHealthConstants.nHanesYears[0]];
      }
    }

    this.sharedService.setSeletedDataSets(this.selectedDataSets);
    
    this.sharedService.selectedDataSets.subscribe(data => {
      if (data) {
        if (this.isDemoUser) {
          this.selectedDataSets = [vennHealthConstants.nHanesYears[0]];
        } else {
          this.selectedDataSets = data;
        }
      }
    });

    this.sharedService.validationErrors.subscribe(errors => {
      if (errors) {
        this.validationErrors = errors;
        this.hasErrors = this.validationErrors.some(i => i.indicationName === 'datasets');
      }
    });
  }

  get isIndet() {
    return (
      this.selectedDataSets.length !== 0 && this.selectedDataSets.length !== this.availableDataSets.length
    );
  }

  get toggleAllText() {
    return this.isChecked ? "Deselect All" : "Select All";
  }

  isItemSelected(item) {
    return this.selectedDataSets.some((x) => x.value === item.value);
  }

  onSelectAllClick() {
    this.isChecked = !this.isChecked;
    this.selectedDataSets = this.isChecked ? this.availableDataSets.slice() : [];
    this.sharedService.setSeletedDataSets(this.selectedDataSets);
  }

  onValueChange() {
    this.isChecked = this.selectedDataSets.length === this.availableDataSets.length;
    this.sharedService.setSeletedDataSets(this.selectedDataSets);
  }

  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean {
    // if (this.isDemoUser) {
      return itemArgs.index > 0;// disable all except the oldest data set for the demo
    // }
    // return false;
  }
}
